module.exports = __webpack_public_path__ + "static/media/dark-theme-logo.e2f28a39.png";